export const convertScopeType = (type) => {
  switch (type) {
    case 'my_calendly':
    case 'user_single':
      return 'user'
    case 'page_single':
      return 'team'
    default:
      throw new Error(`Unsupported type ${type}`)
  }
}
